import React from "react";
import {
  IoDocumentTextOutline,
  IoImageOutline,
  IoGridOutline,
  IoBarChartOutline,
  IoMusicalNotesOutline,
  IoVideocamOutline,
  IoTrashOutline,
} from "react-icons/io5";

const IMAGE_EXTS = ["png", "jpg", "jpeg", "gif", "bmp", "webp", "svg", "tiff"];
const SHEET_EXTS = ["xls", "xlsx", "csv"];
const SLIDE_EXTS = ["ppt", "pptx"];
const AUDIO_EXTS = ["mp3", "ogg", "wav", "aac", "flac", "m4a", "amr"];
const VIDEO_EXTS = ["mp4", "webm", "ogv", "avi", "mov"];

const STATUS_BADGES = {
  uploaded: { label: "En attente", className: "bg-secondary" },
  indexing: { label: "Indexation…", className: "bg-warning text-dark" },
  indexed: { label: "Indexé", className: "bg-success" },
  failed: { label: "Échec", className: "bg-danger" },
};

function FileTypeIcon({ fileName }) {
  const ext = (fileName || "").split(".").pop().toLowerCase();
  if (IMAGE_EXTS.includes(ext)) return <IoImageOutline />;
  if (SHEET_EXTS.includes(ext)) return <IoGridOutline />;
  if (SLIDE_EXTS.includes(ext)) return <IoBarChartOutline />;
  if (AUDIO_EXTS.includes(ext)) return <IoMusicalNotesOutline />;
  if (VIDEO_EXTS.includes(ext)) return <IoVideocamOutline />;
  return <IoDocumentTextOutline />;
}

function formatFileSize(bytes) {
  if (!bytes) return "—";
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}

function formatDate(value) {
  if (!value) return "";
  try {
    const d = new Date(value);
    return d.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return value;
  }
}

export default function RagFilesList({ files, loading, onDelete }) {
  const handleDelete = (id) => {
    if (!onDelete || !id) return;
    onDelete(id);
  };

  return (
    <div className="card border-0 mb-4">
      <div className="card-header bg-transparent border-bottom d-flex align-items-center gap-2">
        <IoDocumentTextOutline size={20} />
        <h5 className="mb-0">Documents de la base de connaissances</h5>
        <span className="badge text-bg-light ms-auto">{files.length}</span>
      </div>
      <div className="card-body p-0">
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status" />
          </div>
        ) : files.length === 0 ? (
          <p className="text-center text-muted py-4 mb-0">
            Aucun document pour le moment. Glissez-déposez ou ajoutez un fichier
            pour alimenter la base de connaissances de Pélagie.
          </p>
        ) : (
          files.map((f) => {
            const badge = STATUS_BADGES[f.status] || STATUS_BADGES.uploaded;
            return (
              <div
                key={f._id}
                className="d-flex align-items-center gap-3 p-3 border-bottom"
              >
                <span
                  className="text-primary flex-shrink-0 d-flex"
                  style={{ fontSize: "24px" }}
                >
                  <FileTypeIcon fileName={f.fileName} />
                </span>
                <div className="flex-fill min-w-0">
                  <strong className="d-block text-truncate">{f.fileName}</strong>
                  <small className="text-muted">
                    {formatFileSize(f.size)} — {formatDate(f.createdAt)}
                  </small>
                </div>
                <span
                  className={`badge ${badge.className} flex-shrink-0`}
                >
                  {badge.label}
                </span>
                <button
                  className="btn btn-sm btn-outline-danger flex-shrink-0"
                  title="Supprimer"
                  onClick={() => handleDelete(f._id)}
                >
                  <IoTrashOutline />
                </button>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}